import React from 'react';
import { InputNumber, type InputNumberProps } from 'antd';
import {
  formatTrInputNumber,
  parseTrInputNumber,
  TR_DECIMAL_SEPARATOR,
} from '../utils/trNumber';

export type TrInputNumberProps = InputNumberProps<number> & {
  /** Yıl, adet vb. tam sayı alanları — ondalık yok, yalnızca rakam */
  integerOnly?: boolean;
};

/**
 * Türkçe ondalık destekli InputNumber.
 * 10,5 → 10.5 (virgül silinip 105 olmaz). Kayıtlar yine number/decimal gider.
 */
export const TrInputNumber = React.forwardRef<HTMLInputElement, TrInputNumberProps>(
  function TrInputNumber({ integerOnly, decimalSeparator, parser, formatter, ...rest }, ref) {
    if (integerOnly) {
      return (
        <InputNumber<number>
          ref={ref as any}
          parser={
            parser ??
            ((value) => {
              const digits = value?.replace(/[^\d-]/g, '') ?? '';
              if (!digits || digits === '-') return Number.NaN;
              const n = parseInt(digits, 10);
              return Number.isFinite(n) ? n : Number.NaN;
            })
          }
          formatter={
            formatter ??
            ((value) => {
              if (value === undefined || value === null) return '';
              if (typeof value === 'number' && Number.isNaN(value)) return '';
              return `${value}`;
            })
          }
          {...rest}
        />
      );
    }

    return (
      <InputNumber<number>
        ref={ref as any}
        decimalSeparator={decimalSeparator ?? TR_DECIMAL_SEPARATOR}
        parser={parser ?? parseTrInputNumber}
        formatter={formatter ?? formatTrInputNumber}
        {...rest}
      />
    );
  }
);

export default TrInputNumber;
